import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import HistoryDetailPage from "../../components/History/Detail";
import TransferHistory from "../../components/History/TransferHistory";
import Loading from "../../components/Main/Loading";
import Rating from "../../components/Main/Rating";
import ToastError from "../../components/Notification/ToastError";
import { authsignature, storage } from "../../libs";
import { ValRate } from "../../validation/RatingValidation";

function HistoryDetail(props) {
  const location = useLocation();
  const history = useHistory();
  const id = props.match.params.id;
  const [control, setControl] = useState(true); // true. Pembelian (2), false. Pemeriksaan (1)
  const [isModal, setModal] = useState();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadKwi, setLoadKwi] = useState(false);
  const [loadReport, setLoadReport] = useState(false);

  const [isPayment, setPayment] = useState(false);

  const element = [1, 2, 3, 4, 5];
  const [loadingRate, setLoadingRate] = useState(false);
  const [rate, setRate] = useState({
    transaction_id: 0,
    rating: 5,
    description: "",
  });

  const [isError, setError] = useState([]);

  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState("");
  const onError = () => {
    setOpen(false);
  };

  const GetData = async () => {
    setLoading(true);

    try {
      const auth = await storage();
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/transaction/history/detail`,
        {
          transaction_id: id,
          reference: location.pathname.includes("pembelian") ? "2" : "1",
        },
        {
          headers: await authsignature(auth.token, {
            transaction_id: id,
            reference: location.pathname.includes("pembelian") ? "2" : "1",
          }),
        }
      );

      if (Number(response.data.code) === 200) {
        setLoading(false);
        setData(response.data.data);
      } else {
        setLoading(false);
        history.push("/page-not-found");
      }
    } catch (e) {
      setLoading(false);
      history.push("/page-not-found");
    }
  };

  useEffect(() => {
    GetData();
    setRate({ ...rate, transaction_id: id });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (location.pathname.includes("pembelian")) {
      setControl(false);
    } else if (location.pathname.includes("pemeriksaan")) {
      setControl(true);
    }
  }, [location]);

  /** Modal Section */
  const onModal = () => {
    setModal(true);
  };

  const onCancel = () => {
    setModal(false);
    onReset();
  };

  const onSubmit = async () => {
    setLoadingRate(true);
    const error = await ValRate(rate);

    if (error.length > 0) {
      setError(error);
      setLoadingRate(false);
    } else {
      try {
        const auth = await storage();
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/transaction/ratings`,
          rate,
          { headers: await authsignature(auth.token, rate) }
        );
        if (Number(response.data.code) === 200) {
          onReset();
          setLoadingRate(false);
          await GetData();
          setModal(false);
        } else {
          setLoadingRate(false);

          setOpen(true);
          setResponse("");
        }
      } catch (error) {
        onReset();
        setModal(false);
        setLoadingRate(false);

        setOpen(true);
        setResponse("");
      }
    }
  };

  const onChange = (name, value) => {
    setError([]);
    if (name === "rating") {
      setRate({
        ...rate,
        rating: value.toString(),
      });
    } else if (name === "description") {
      setRate({
        ...rate,
        description: value,
      });
    }
  };

  const onReset = () => {
    setRate({
      ...rate,
      rating: 5,
      description: "",
    });
    setError([]);
  };

  const onDownload = async () => {
    setLoadKwi(true);
    try {
      const auth = await storage();
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/payment/cetak-kwitansi`,
        {
          transaction_id: id,
        },
        {
          responseType: "arraybuffer",
          headers: await authsignature(auth.token, {
            transaction_id: id,
          }),
        }
      );

      if (response.data && Number(response.status) === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${data.no_invoice}_${data.nama_pasien}_${moment(
            data.tgl_registrasi
          ).format("DDMMYYYYHHmmss")}.pdf`
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
        setLoadKwi(false);
      } else {
        setLoadKwi(false);
        setOpen(true);
        setResponse("");
      }
    } catch (e) {
      setLoadKwi(false);
      setOpen(true);
      setResponse("");
    }
  };

  const onReport = async () => {
    setLoadReport(true);
    try {
      const auth = await storage();
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/transaction/cetak-hasil`,
        {
          transaction_id: id,
        },
        {
          responseType: "arraybuffer",
          headers: await authsignature(auth.token, {
            transaction_id: id,
          }),
        }
      );

      if (response.data && Number(response.status) === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `hasil_${data.no_invoice}_${data.nama_pasien}_${moment(
            data.tgl_registrasi
          ).format("DDMMYYYYHHmmss")}.pdf`
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
        setLoadReport(false);
      } else {
        setLoadReport(false);
        setOpen(true);
        setResponse("");
      }
    } catch (e) {
      setLoadReport(false);
      setOpen(true);
      setResponse("");
    }
  };

  const onRilis = async () => {
    // const convert = await converts({
    //   id,
    //   invoice: data.no_invoice,
    //   no_hp: data.no_telp.toString(),
    // });

    history.push(`/result/${data.encrypt}`);
  };

  const onTransfer = () => {
    setPayment(true);
  };

  const onClose = () => {
    setPayment(false);
  };

  return (
    <>
      <ToastError props={{ open, response, onError }} />
      <Rating
        props={{
          isModal,
          onCancel,
          onSubmit,
          element,
          onChange,
          rate,
          isError,
          loadingRate,
          data,
        }}
      />
      <TransferHistory
        props={{
          isPayment,
          onClose,
          dataTransfer: data?.info_pembayaran ?? {},
        }}
      />
      {loading ? (
        <Loading />
      ) : (
        <HistoryDetailPage
          props={{
            id,
            control,
            onModal,
            data,
            onDownload,
            loadKwi,
            onReport,
            loadReport,
            location,
            onRilis,
            onTransfer,
          }}
        />
      )}
    </>
  );
}

export default HistoryDetail;
